import { Button, Typography } from '@ace-clublabs/shared-component-library';
import CookieHelper from '../../utils/cookieHelper';
import { useGlobalState } from '../../state/state';

export const ExploreBenefitButton = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const zipCode =
    memberDetails.loggedInMember?.residenceAddress?.zip || CookieHelper.getZipcodeFromZipcodeCookie() || '';

  return (
    <Button
      className="explore-benefit-button"
      size="medium"
      label={
        <Typography sx={{ fontSize: '1rem !important', fontWeight: '500', lineHeight: '1.5rem', color: '#0C72DF' }}>
          Explore & compare full benefits
        </Typography>
      }
      variant="outlined"
      onClick={() => {
        window.open('https://www.ace.aaa.com/membership/benefit-chart.html?zip=' + zipCode, '_blank');
      }}
      sx={{ width: '17rem', marginTop: '1.5rem', alignSelf: 'center' }}
    />
  );
};
